
define('eteration/widgets/ui-money',[
	'knockout',
	'eteration/eteration-i18n',
    'eteration/eteration-ajax',
	'ui-helper/currency-helper',
	'underscore'
], function(ko,i18n,etrAjax,currencyHelper, underscore) {
	
	var userCountry = i18n.getUserCountry();
	var currencySymbols;
	try {
		currencySymbols = localStorage.currencySymbols ? JSON.parse(localStorage.currencySymbols): undefined;
	} catch (e) {}

	if(!currencySymbols || !currencySymbols.decimalCounts || userCountry != currencySymbols.country) {
		etrAjax.get({
			app : 'app.common',
			service : '/parameters/countrymoneysettings',
			disableLoader : true,
			callback : function(response) {
				if(response.data) {
					if(response.data.countryMoneySeperatorSymbols) {
						currencySymbols = {
							'country': userCountry,
							'digit': response.data.countryMoneySeperatorSymbols.digitGroupingSymbol,
							'decimal': response.data.countryMoneySeperatorSymbols.decimalPlacerSymbol || ','
						}
					}
					if(response.data.currencyDecimalCounts) {
						currencySymbols.decimalCounts = response.data.currencyDecimalCounts;
					}
					localStorage.currencySymbols = JSON.stringify(currencySymbols);
				}
			},
			preError: function() {
				currencySymbols = {
					'country': userCountry,
					'digit': '.',
					'decimal': ',',
					'decimalCounts':{}
				};
			}
		});
	}
	
	function priceTemplateBinder(element, currency, amount, decimal, hideDecimal, br, plusSign, reShopProcess){
		
		var amountWithDigit = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, currencySymbols.digit);
		
		if(currency.code == 'MILE' || currency.code == 'PTS' || currency.code == 'MIL') {
			var appendMilesPrice = function() {
				amount = amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + currencySymbols.digit);
				var milePrice = '';
				if(!element.getAttribute('isAwardTicket')){
					milePrice = i18n.getWithArgs("Label-MS-MILES-410", {'mileamount': amount });
					$(element).append("<span>" + milePrice + "</span>");
				}else{
					milePrice= i18n.get('Label-MS-MILES-20034') + "<span>" + amount + "</span>"
					$(element).append("<span class='at-mile'>" + milePrice + "</span>");
				}

				if(plusSign && !reShopProcess){
					$(element).append('<span class="plus">+</span>');
				} 
			}

			i18n.loadMsgs(['ms'],function(){ appendMilesPrice(); },"ui-money");
			
			return;
		}
		
		if (br) {
			$(element).append('<br/>');
		}
		
		if(currency.code){
			if(reShopProcess && plusSign) {
				currency.code = "+" + currency.code;
				$(element).append("<span class=\"dib price-column-currency-for-reshop\">" + currency.code + "</span>");
			} else {
				$(element).append("<span class=\"dib price-column-currency\">" + currency.code + "</span>");
			}
		}

		if(decimal != '' && (hideDecimal == 'NEVER' || (hideDecimal == 'FOR_INTEGERS' && decimal != '00' ))) {
			var str = '<span class="ws-nowrap" id="amount-of-price">' + amountWithDigit + '</span><span class="price-column-decimal">' +
				currencySymbols.decimal + decimal +'</span>';
			$(element).append(str);
		}else{
			if(currency.code && amount.toString().length > 7)
				$(element).append('<span class="dib ws-nowrap">' + amountWithDigit + '</span>');
			else
				$(element).append('<span class="ws-nowrap" id="amount-of-price">' + amountWithDigit + '</span>');
		}
			
		if(plusSign && !reShopProcess){
			$(element).append('<span class="plus">+</span>');
		}
	}
	
	ko.bindingHandlers.money = {
		update : function(element, valueAccessor, _allBindingsAccessor) {

			var accessor = valueAccessor();
			var c = ko.utils.unwrapObservable(accessor.currency);
			var a = ko.utils.unwrapObservable(accessor.amount);
			
			var money = a.toLocaleString(i18n.getUserLocale(), {
				style: 'currency',
				currency: c,
				minimumFractionDigits: 2
			});
			
			$(element).text(money);
		}
	};
	
	ko.bindingHandlers.price = {
		update : function(element, valueAccessor, _allBindingsAccessor) {

			var accessor = valueAccessor();
			var currency = ko.utils.unwrapObservable(accessor.currency);
			var amount = ko.utils.unwrapObservable(accessor.amount);
			
			var hideDecimal = ko.utils.unwrapObservable(accessor.hideDecimal) || 'NEVER'; //ALWAYS, FOR_INTEGERS, NEVER
			
			var roundingMode = ko.utils.unwrapObservable(accessor.roundingMode) || 'NONE'; //HALF_UP, HALF_DOWN, CEILING, FLOOR, NONE
			
			var plusSign = ko.utils.unwrapObservable(accessor.plusSign) || false;

			var reShopProcess = ko.utils.unwrapObservable(accessor.reShopProcess) || false;

			if (roundingMode == 'CEILING') {
				amount = Math.ceil(amount);
			} else if (roundingMode == 'FLOOR') {
				amount = Math.floor(amount);
			}
			
			var integerPart = getIntegerPart(amount);
			var decimalPart = getDecimalPart(amount, currency);
			var currencyData = getCurrencyData(currency);
			
			$(element).empty();
			priceTemplateBinder(element, currencyData, integerPart, decimalPart, hideDecimal, false, plusSign, reShopProcess)

		}
	};
	
	ko.bindingHandlers.flightPrice = {
		update : function(element, valueAccessor, _allBindingsAccessor) {
			
			$(element).empty();
			
			var accessor = valueAccessor();
			var flight = ko.utils.unwrapObservable(accessor.flight);
			var hideDecimal = ko.utils.unwrapObservable(accessor.hideDecimal) || 'ALWAYS';
			var roundingMode = ko.utils.unwrapObservable(accessor.roundingMode) || 'CEILING';			
			
			var baseCode = ko.utils.unwrapObservable(flight.priceForSelectedFareBasisCode);
			
			if(baseCode) {
				var amount;
				var currencyData;

				if(baseCode.convertedPrices['ORIGINAL_PRICE']){
					currencyData = getCurrencyData(baseCode.convertedPrices['ORIGINAL_PRICE'].currency);
					amount = baseCode.convertedPrices['ORIGINAL_PRICE'].amount;
				}

				if (roundingMode == 'CEILING') {
					amount = Math.ceil(amount);
				} else if (roundingMode == 'FLOOR') {
					amount = Math.floor(amount);
				}
				var integerPart = getIntegerPart(amount);
				var decimalPart = currencyData && getDecimalPart(amount, currencyData.code);

				currencyData && integerPart && priceTemplateBinder(element, currencyData, integerPart, decimalPart, hideDecimal, false, false)

				if(baseCode.preferedCurrencyPrice){
					currencyData = getCurrencyData(baseCode.preferedCurrencyPrice.currency);
					
					amount = baseCode.preferedCurrencyPrice.amount;
					if (roundingMode == 'CEILING') {
						amount = Math.ceil(amount);
					} else if (roundingMode == 'FLOOR') {
						amount = Math.floor(amount);
					}
					integerPart = getIntegerPart(amount);
					decimalPart = getDecimalPart(amount, currencyData.code);
					priceTemplateBinder(element, currencyData, integerPart, decimalPart, hideDecimal, true, false)
				}

			} else {
				$(element).append('<span>-</span>')
			}

		}
	};
	
	ko.bindingHandlers.amount = {
		update : function(element, valueAccessor, _allBindingsAccessor) {

			var accessor = valueAccessor();
			var currencyText = ko.utils.unwrapObservable(accessor.currency);
			var amountText = ko.utils.unwrapObservable(accessor.amount);
			
			var amount = getIntegerPart(amountText);
			var currencyData = getCurrencyData(currencyText);
			var decimal	= getDecimalPart(amountText, currencyData.code);
			
			$(element).empty();
			
			var icon = getCurrencyObjectIcon(currency);
			if(currencyData.side) {
				$(element).append(icon);
			}
			var amountWithDigit = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, currencySymbols.digit);
			$(element).append('<span class="ws-nowrap" id="amount-of-price">' + amountWithDigit +'</span>');
			$(element).append('<span>' + currencySymbols.decimal + decimal +'</span>');
			
			if(!currencyData.side) {
				$(element).append(icon);
			}
			
		}
	};
	

	var sign = function(number) {
		var n = number && (number / Math.abs(number));
		return isNaN(n) ? Math.abs(number) : n;
	}
	
	var getIntegerPart = function(amount){
		return sign(amount) * Math.floor(Math.abs(amount));
	};
	
	var getDecimalPart = function(amount, currency) {
		currency = currency || 'TRY';
		var count = (currencySymbols && currencySymbols.decimalCounts[currency]) ?
				currencySymbols.decimalCounts[currency].decimalCount : 2;
		var decimal = '';
		if(amount.toString().indexOf('.') > -1) {
			decimal = amount.toString().split('.')[1];
			decimal = (decimal + '000000000').substr(0, count);
		} else if(count) {
			decimal = '000000000'.substr(0, count);
		}
		return decimal;
	};
	
	var getCurrencyObjectIcon = function(currencyData){
		return  "<i class=\"fa "+ (currencyData.icon || currencyData.sign) +"\"></i>";
	}
	
	var getCurrencyData = function(currency) {
	
		var foundCurrencyData = underscore.find(currencyDataArray, function(currencyData) {
			if(this.toUpperCase){
				return currencyData.code == this.toUpperCase() 
			}
			return false;
		}, currency)
		
		return foundCurrencyData || { code : currency, sign : currency, icon : '', side : false }

	};
	
	ko.virtualElements.allowedBindings.money = true;
	
	self.currencyDataArray = currencyHelper.currencyList;

	//need currency but returns only price
	var getPriceStrDecimal = function(amount, currency, hideDecimal, roundingMode){
		
		//ALWAYS, FOR_INTEGERS, NEVER
		hideDecimal = hideDecimal || 'NEVER';
		
		//HALF_UP, HALF_DOWN, CEILING, FLOOR, NONE
		roundingMode = roundingMode || 'NONE';
		currency = currency || 'TRY';
		
		if (roundingMode == 'CEILING') {
			amount = Math.ceil(amount);
		} else if (roundingMode == 'FLOOR') {
			amount = Math.floor(amount);
		}
		
		var integerPart = getIntegerPart(amount);
		var decimalPart = getDecimalPart(amount, currency);
		
		var amountWithDigit = integerPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, currencySymbols.digit);
		var price = amountWithDigit;
		if(decimalPart != '' && (hideDecimal == 'NEVER' || (hideDecimal == 'FOR_INTEGERS' && decimalPart != '00' ))){
			price += currencySymbols.decimal + decimalPart;
		}
		
		return price;
	}

	//this function adjusts the amount in the input according to locale currency symbols
	var getMoneyByLocale = function(amount, lengthAfterDecimal){
		amount = amount.toString().replace(/[^0-9\.,]/g, "").replace(currencySymbols.digit, currencySymbols.decimal);
		if(amount.indexOf(currencySymbols.decimal) != -1){
			amount = amount.split(currencySymbols.decimal)[0] + currencySymbols.decimal + amount.split(currencySymbols.decimal)[1].substr(0,lengthAfterDecimal);
		}
		return amount;
	}

	//if has currency returns price with currency. if hasnot currency returns price without 
	var getPriceStr = function(amount, currency, hideDecimal, roundingMode, isForMileAmount){

		//ALWAYS, FOR_INTEGERS, NEVER
		hideDecimal = hideDecimal || 'NEVER';
		
		//HALF_UP, HALF_DOWN, CEILING, FLOOR, NONE
		roundingMode = roundingMode || 'NONE';
		
		if (currency == '') {
			price = amount; 	
		}
		else {
		
			if (roundingMode == 'CEILING') {
				amount = Math.ceil(amount);
			} else if (roundingMode == 'FLOOR') {
				amount = Math.floor(amount);
			}
			
			var integerPart = getIntegerPart(amount);
			var decimalPart = getDecimalPart(amount, currency);
			
			var amountWithDigit = integerPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, currencySymbols.digit);
			var price = amountWithDigit;
			if(decimalPart != '' && (hideDecimal == 'NEVER' || (hideDecimal == 'FOR_INTEGERS' && decimalPart != '00' ))){
				price += currencySymbols.decimal + decimalPart;
			}
			
			if(isForMileAmount){
				amount = amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
				price = i18n.getWithArgs("Label-MS-MILES-410", {'mileamount': amount });
			}else{
				price = currency + ' '+ price;
			}
			
		}
	
		return price;
	}

	var getPriceWithDigit = function(amount, hideDecimal, currency, roundingMode) {
		hideDecimal = hideDecimal || 'NEVER';
		roundingMode = roundingMode || 'NONE';
		
		var integerPart = getIntegerPart(amount);
		var decimalPart = getDecimalPart(amount, currency);
		
		var amountWithDigit = integerPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, currencySymbols.digit);
		if(decimalPart != '' && (hideDecimal == 'NEVER' || (hideDecimal == 'FOR_INTEGERS' && decimalPart != '00' ))){
			amountWithDigit += currencySymbols.decimal + decimalPart;
		}

		return amountWithDigit;
	}

	var getMilePriceDotted = function(amount) {
		

		var amountWithDigit = amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + currencySymbols.digit);
		
		return amountWithDigit;
	}
	
	return {
		getPriceStr : getPriceStr,
		getPriceStrDecimal : getPriceStrDecimal,
		getPriceWithDigit : getPriceWithDigit,
		priceTemplateBinder : priceTemplateBinder,
		getMilePriceDotted: getMilePriceDotted,
		getMoneyByLocale: getMoneyByLocale
    };

});
